import React from "react";
import { Box, Typography, IconButton, Stack } from "@mui/material";
import { Instagram, WhatsApp } from "@mui/icons-material";

const ContactPage = () => {
  return (
    <Box
      sx={{
        minHeight: "85vh",
        mt: "10vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        px: { xs: 2, sm: 4, md: 0 },
      }}
    >
      {/* MAIN GREEN CONTAINER */}
      <Box
        sx={{
          bgcolor: "#1E412D",
          color: "#F5EDE3",
          borderRadius: { xs: 0, md: "12px" },
          textAlign: "justify",
          boxSizing: "border-box",
          px: { xs: "10px", sm: "20px", md: "80px" },
          py: { xs: 5, sm: 7, md: 10 },
          mt: "30px",
          mx: { xs: 0, md: "100px" },
          width: { xs: "100%", sm: "100%", md: "calc(100% - 200px)" },
        }}
      >
        {/* HEADING */}
        <Typography
          variant="h3"
          sx={{
            fontFamily: "Playfair Display, serif",
            fontWeight: 700,
            textAlign: "center",
            mb: 6,
            color: "#F5EDE3",
            fontSize: { xs: "2rem", sm: "3rem", md: "3.8rem", lg: "4rem" },
            lineHeight: 1.2,
          }}
        >
          Contact Us
        </Typography>

        {/* INTRO PARAGRAPHS */}
        <Typography
          variant="body1"
          sx={{
            fontFamily: "Lora, serif",
            fontSize: { xs: "1rem", sm: "1.1rem" },
            lineHeight: 1.9,
            mb: 3,
          }}
        >
          Welcome to <strong>The Blush Story by Aarti Soni</strong> — where
          artistry, elegance, and passion come together to celebrate your most
          beautiful moments. We’re so happy that you’ve taken the time to reach
          out and explore what we do. At The Blush Story, every brushstroke is a
          love letter to confidence, individuality, and timeless beauty. Whether
          you’re a bride preparing for your big day, attending a special event,
          or simply looking to indulge in a bit of self-care, we’re here to make
          sure you feel nothing short of extraordinary.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontFamily: "Lora, serif",
            fontSize: { xs: "1rem", sm: "1.1rem" },
            lineHeight: 1.9,
            mb: 3,
          }}
        >
          Aarti’s philosophy is rooted in enhancing natural beauty through
          carefully curated looks that reflect your personality and style. With
          years of professional experience and a deep understanding of diverse
          skin tones and aesthetics, she ensures each transformation feels
          personal, polished, and radiant. From dewy daytime glows to bold,
          glamorous evenings, every session is designed to make you feel seen,
          celebrated, and confident in your own skin.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontFamily: "Lora, serif",
            fontSize: { xs: "1rem", sm: "1.1rem" },
            lineHeight: 1.9,
            mb: 6,
          }}
        >
          We would love to connect with you personally to discuss your dream
          look or upcoming occasion. Whether you want to book a bridal session,
          a festive makeover, or just need expert advice on what suits you best
          — Aarti is just a message away. Reach out on Instagram to explore her
          latest work or drop a WhatsApp message to chat directly. Let’s begin
          your blush story together — with artistry, warmth, and a touch of
          magic ✨.{" "}
          <strong>
            For more details do click the links below to connect with us.
          </strong>
        </Typography>

        {/* SOCIAL LINKS SECTION */}
        {/* WhatsApp Section with two numbers */}
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={{ xs: 2, sm: 4 }}
          sx={{
            mt: 2,
            flexWrap: "wrap",
            gap: { xs: 2, sm: 3 },
          }}
        >
          {/* Instagram */}
          <Box
            component="a"
            href="https://www.instagram.com/the_blushstory_by_aarti/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              textDecoration: "none",
              color: "#F5EDE3",
              display: "flex",
              alignItems: "center",
              transition: "opacity 0.3s",
              "&:hover": { opacity: 0.8 },
            }}
          >
            <IconButton
              sx={{
                color: "#F5EDE3",
                mr: { xs: 0.5, sm: 1 },
                p: { xs: 0.5, sm: 1 },
              }}
            >
              <Instagram sx={{ fontSize: { xs: 24, sm: 32, md: 36 } }} />
            </IconButton>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Lora, serif",
                fontWeight: 500,
                fontSize: { xs: "0.9rem", sm: "1.1rem", md: "1.25rem" },
              }}
            >
              @the_blushstory_by_aarti
            </Typography>
          </Box>

          {/* WhatsApp 1 */}
          <Box
            component="a"
            href="https://wa.me/917385999828?text=Hi%21%20I%20came%20from%20your%20website%20and%20would%20love%20to%20know%20more%20about%20your%20services."
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              textDecoration: "none",
              color: "#F5EDE3",
              display: "flex",
              alignItems: "center",
              transition: "opacity 0.3s",
              "&:hover": { opacity: 0.8 },
            }}
          >
            <IconButton
              sx={{
                color: "#F5EDE3",
                mr: { xs: 0.5, sm: 1 },
                p: { xs: 0.5, sm: 1 },
              }}
            >
              <WhatsApp sx={{ fontSize: { xs: 24, sm: 32, md: 36 } }} />
            </IconButton>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Lora, serif",
                fontWeight: 500,
                fontSize: { xs: "0.9rem", sm: "1.1rem", md: "1.25rem" },
              }}
            >
              +91&nbsp;73859&nbsp;99828 (India)
            </Typography>
          </Box>

          {/* WhatsApp 2 */}
          <Box
            component="a"
            href="https://wa.me/971553516029?text=Hi%21%20I%20came%20from%20your%20website%20and%20would%20love%20to%20know%20more%20about%20your%20services."
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              textDecoration: "none",
              color: "#F5EDE3",
              display: "flex",
              alignItems: "center",
              transition: "opacity 0.3s",
              "&:hover": { opacity: 0.8 },
            }}
          >
            <IconButton
              sx={{
                color: "#F5EDE3",
                mr: { xs: 0.5, sm: 1 },
                p: { xs: 0.5, sm: 1 },
              }}
            >
              <WhatsApp sx={{ fontSize: { xs: 24, sm: 32, md: 36 } }} />
            </IconButton>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Lora, serif",
                fontWeight: 500,
                fontSize: { xs: "0.9rem", sm: "1.1rem", md: "1.25rem" },
              }}
            >
              +971&nbsp;55351&nbsp;6029 (UAE)
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default ContactPage;
